/**
 * Map a bet amount to chip Tailwind classes. Casino convention: low
 * denominations in cool colors, high denominations in gold + purple.
 * Keeps the felt visually readable — the user can gauge bet sizes by
 * color before parsing the number.
 */
export type ChipClasses = {
  bg: string;
  text: string;
  ring: string;
};

export function chipClassesFor(amount: number): ChipClasses {
  if (amount >= 1000) {
    return {
      bg: 'bg-chip-gold',
      text: 'text-bg-deeper',
      ring: 'shadow-[0_0_10px_hsl(var(--color-chip-gold)/0.7),inset_0_0_0_2px_hsl(var(--color-bg-deeper))]',
    };
  }
  if (amount >= 500) {
    return {
      bg: 'bg-chip-purple',
      text: 'text-fg',
      ring: 'shadow-[0_0_10px_hsl(var(--color-chip-purple)/0.6),inset_0_0_0_2px_hsl(var(--color-bg-deeper))]',
    };
  }
  if (amount >= 100) {
    return {
      bg: 'bg-chip-blue',
      text: 'text-fg',
      ring: 'shadow-[0_0_10px_hsl(var(--color-chip-blue)/0.6),inset_0_0_0_2px_hsl(var(--color-bg-deeper))]',
    };
  }
  if (amount >= 25) {
    return {
      bg: 'bg-chip-red',
      text: 'text-fg',
      ring: 'shadow-[0_0_10px_hsl(var(--color-chip-red)/0.6),inset_0_0_0_2px_hsl(var(--color-bg-deeper))]',
    };
  }
  return {
    bg: 'bg-chip-green',
    text: 'text-bg-deeper',
    ring: 'shadow-[0_0_10px_hsl(var(--color-chip-green)/0.6),inset_0_0_0_2px_hsl(var(--color-bg-deeper))]',
  };
}
